import React from "react";
import theme from "../../../styles/theme";

const FooterBasic = () => {
  return (
    <footer
      style={{
        position: "relative",
        width: "100%",
        backgroundColor: theme.colors.background.footer,
        borderTop: theme.borders.width.thin,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end", // <== centré à droite
        fontSize: theme.fontSizes.sm,
        color: theme.colors.text.muted,
        padding: "12px 24px",
        boxSizing: "border-box",
        height: "100%",
        overflow: "visible",
        zIndex: 1000
      }}
    >
      <span style={{ marginRight: theme.spacing.md }}>
        © 2025 Quantum Corelia
      </span>
    </footer>
  );
};

export default FooterBasic;
